import Debounce from "../utils/debounce.js";
import EventStack from "../utils/eventStack.js";
export default {
  masthead: null,
  init() {
    this.masthead = document.getElementById('masthead');
    this.addOffset();
    const that = this; 
    
    const handleSwiper = Debounce.create(() => {
      that.removeOffset();
      that.addOffset();
    }, 200);
    
    EventStack.on(window, "resize", handleSwiper); 
    EventStack.on(window, "scroll", this.handleScroll.bind(this)); 
  },
  addOffset() {
    // Set initial padding for the body
    document.body.style.paddingTop = `${this.masthead.clientHeight}px`;
    
    // Add initial fixed class to masthead
    this.masthead.classList.add('fixed');
  },
  removeOffset() {

  },
  handleScroll() {
    // Append class based on scroll position
    if (window.scrollY > 50) {
      this.masthead.classList.add('scrolled');
    } else {
      this.masthead.classList.remove('scrolled');
    }
  },
}
